import { Box, Stack } from '@mui/material'
import { useValuationTenantListPage } from './ValuationTenantListPage.data'
import { TenantBreakdownTable, tokens, ViewSwitch } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { useState } from 'react'
import { getTableViews, TableViewValues } from './constants'
import { TenantListKeyValues } from './TenantListKeyValues'
import { ValuationTenantListPageLoading } from './ValuationTenantListPage.load'
import { TenantDetailsTable } from 'ComponentLibrary/src/widgets/TenantTables/TenantDetailsTable/TenantDetailsTable'
import { useTranslation } from 'react-i18next'
import { getTenantBreakdownTableCopy } from '../tenantBreakdownTableCopy'
import { getTenantDetailsTableCopy } from 'ClientPortal/src/common/tenantDetailsTable'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export default function ValuationTenantListPage() {
    const { t: tTenantListPage } = useTranslation('pages', { keyPrefix: 'assets.assetDetails.valuation.valuationTenantListPage' })
    const { t: tTenantDetailsTable } = useTranslation('pages', {
        keyPrefix: 'assets.assetDetails.valuation.valuationTenantListPage.tenantDetailsTable',
    })
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tTenantBreakdownTable } = useTranslation('terminology', { keyPrefix: 'common.tenantBreakdownTable' })
    const { t: tTenantRentalStatuses } = useTranslation('terminology', { keyPrefix: 'common.tenantRentalStatuses' })
    const locale = useCurrentResolvedLocale()
    const tableViews = getTableViews(tTenantListPage)
    const { isValuationPending, tenantRows, tenantBreakdown, rentKeyValues, areaKeyValues, numberOfUnitsKeyValues } =
        useValuationTenantListPage()
    const [viewMode, setViewMode] = useState<TableViewValues>(tenantRows.length > 0 ? 'detail' : 'category')
    const tenantBreakdownTableCopy = getTenantBreakdownTableCopy(tCommon, tTenantBreakdownTable)
    const tenantDetailsTableCopy = getTenantDetailsTableCopy(tCommon, tTenantRentalStatuses, tTenantDetailsTable)

    if (isValuationPending) {
        return <ValuationTenantListPageLoading />
    }

    if (!rentKeyValues || !areaKeyValues || !numberOfUnitsKeyValues || tenantRows.length === 0 || tenantBreakdown.length === 0) {
        return null
    }

    return (
        <Stack direction="column" paddingTop={tokens.SizingSpacing100} gap={tokens.SizingSpacing400}>
            <TenantListKeyValues
                rentKeyValues={rentKeyValues}
                areaKeyValues={areaKeyValues}
                numberOfUnitsKeyValues={numberOfUnitsKeyValues}
            />
            <Stack direction="column">
                <Stack
                    direction="row"
                    alignItems="center"
                    padding={tokens.SizingSpacing300}
                    bgcolor={tokens.ColorSurfaceDefault}
                    justifyContent="space-between"
                    width="100%"
                    boxShadow="0px 5px 15px -6px #e6e6e6ff"
                    sx={{ position: 'relative', zIndex: 5 }}
                >
                    <Typography variant="textS" color={tokens.ColorTextSubtle}>
                        {tTenantListPage('rowsLabel', { count: viewMode === 'category' ? tenantBreakdown.length : tenantRows.length })}
                    </Typography>
                    {tenantRows.length > 0 && (
                        <ViewSwitch value={viewMode} items={tableViews} onClick={(newView) => setViewMode(newView as TableViewValues)} />
                    )}
                </Stack>
                <Box paddingX={tokens.SizingSpacing200} paddingBottom={tokens.SizingSpacing200} bgcolor={tokens.ColorSurfaceDefault}>
                    {viewMode === 'category' ? (
                        <TenantBreakdownTable data={tenantBreakdown} copy={tenantBreakdownTableCopy} locale={locale} />
                    ) : (
                        <TenantDetailsTable tenantRows={tenantRows} copy={tenantDetailsTableCopy} locale={locale} />
                    )}
                </Box>
            </Stack>
        </Stack>
    )
}
